export const reviewResults = [
  { 
    key: "Approved", 
    text: "Approved", 
    value: "Approved" 
  },
  { 
    key: "Rejected", 
    text: "Rejected", 
    value: "Rejected" 
  },
  {
    key: "Escalate for Additional Review",
    text: "Escalate for Additional Review",
    value: "Escalate for Additional Review",
  },
  {
    key: "DeEscalated for Additional Review",
    text: "DeEscalated for Additional Review",
    value: "DeEscalated for Additional Review",
  },
];
